import { AuthService } from './../services/auth.service';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable, Injector } from '@angular/core';
import { LoaderService } from '../services/loader-service/loader.service';
import { catchError, finalize } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { SKIP_LOADER } from './skip-loader.context';
import {
    SKIP_LOGOUT_ON_401,
    SKIP_LOGOUT_ON_401_HEADER,
    SKIP_LOGOUT_ON_401_HEADER_VALUE,
} from './skip-logout-on-401.context';
import { LanguageService } from 'src/app/core/i18n/language.service';
import { StorageService, TokenStorageKey } from '../services/storage/storage.service';

@Injectable({ providedIn: 'root' })
export class LoaderInterceptor implements HttpInterceptor {
    private readonly injector = inject(Injector);

    constructor(
        private loaderService: LoaderService,
        private readonly languageService: LanguageService,
        private readonly storage: StorageService,
    ) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const authService = this.injector.get(AuthService);

        const skipLogoutFromHeader = request.headers.get(SKIP_LOGOUT_ON_401_HEADER) === SKIP_LOGOUT_ON_401_HEADER_VALUE;
        const req = request.headers.has(SKIP_LOGOUT_ON_401_HEADER)
            ? request.clone({
                  headers: request.headers.delete(SKIP_LOGOUT_ON_401_HEADER),
              })
            : request;

        const accessToken = this.storage.getLocal(TokenStorageKey.ACCESS_TOKEN);
        const activeLang = this.languageService.getActive() || 'pt-BR';

        const headers: Record<string, string> = {
            'Accept-Language': activeLang,
        };

        if (accessToken) {
            headers['Authorization'] = `Bearer ${accessToken}`;
        }

        const outbound = req.clone({ setHeaders: headers });
        const skipLoader = outbound.context.get(SKIP_LOADER);
        const skipLogoutOn401 = skipLogoutFromHeader || outbound.context.get(SKIP_LOGOUT_ON_401);

        if (!skipLoader) {
            this.loaderService.showLoader();
        }

        return next.handle(outbound).pipe(
            catchError((error: HttpErrorResponse) => {
                authService.handleUnauthorizedResponse(error, skipLogoutOn401);
                return throwError(() => error);
            }),
            finalize(() => {
                if (!skipLoader) {
                    this.loaderService.hideLoader();
                }
            }),
        );
    }
}
